var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99561 12.5C7.99561 11.9477 8.44332 11.5 8.99561 11.5H14.9956C15.5479 11.5 15.9956 11.9477 15.9956 12.5C15.9956 13.0523 15.5479 13.5 14.9956 13.5H8.99561C8.44332 13.5 7.99561 13.0523 7.99561 12.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17C8 16.4477 8.44772 16 9 16H13.7544C14.3067 16 14.7544 16.4477 14.7544 17C14.7544 17.5523 14.3067 18 13.7544 18H9C8.44772 18 8 17.5523 8 17Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8C8 7.44772 8.44772 7 9 7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H9C8.44772 9 8 8.55228 8 8Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2C5.34315 2 4 3.34315 4 5V20C4 21.6569 5.34315 23 7 23H17C18.6569 23 20 21.6569 20 20V5C20 3.34315 18.6569 2 17 2H15.937C15.715 1.13739 14.9319 0.5 14 0.5H10C9.06808 0.5 8.28503 1.13739 8.06301 2H7ZM7 4C6.44772 4 6 4.44772 6 5V20C6 20.5523 6.44772 21 7 21H17C17.5523 21 18 20.5523 18 20V5C18 4.44772 17.5523 4 17 4H15.937C15.715 4.86261 14.9319 5.5 14 5.5H10C9.06808 5.5 8.28503 4.86261 8.06301 4H7ZM14 2.5H10V3.5H14V2.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardX2);
export default __webpack_public_path__ + "static/media/ClipboardX2.5f02d2e5d5de17482c5e491fcd9558ac.svg";
export { ForwardRef as ReactComponent };